import {updateTodoList} from '../../../../../actions/todo_list/todo_list';

export const actions = {
    SET_PICTURE: "SET_PICTURE",
    SET_PICTURE_UI: "SET_PICTURE_UI",
    GET_PICTURE: "GET_PICTURE",
    GET_PICTURE_ERROR: "GET_PICTURE_ERROR",
    POST_PICTURE_REQUEST: "POST_PICTURE_REQUEST",
    POST_PICTURE_SUCCESS: "POST_PICTURE_SUCCESS",
    POST_PICTURE_ERROR: "POST_PICTURE_ERROR",
}

export const setPicture = ( personId, url ) => {
    const isDefault = url.indexOf("default.png") > -1 ? true : false;
    return {
            type: actions.SET_PICTURE,
            personId,
            url,
            isDefault,
    }
}

export const setPictureUI = () => {
    return {
        type: actions.SET_PICTURE_UI,
        pictureIsError: false,
        pictureIsFetching: false,
    }
}

export const getPictureError = ( error ) => {
    return {
        type: actions.GET_PICTURE_ERROR,
        pictureIsError: true,
        pictureIsFetching: false,
        error,
    }
}

// fetch function is used on second promise on the getProfile action creator
export const getPicture = ( personId ) => {
    // const  url = new Request (`https://s3.intouchnetworks.com/getImage.php?id=${ personId }`);
    return  dispatch  => {
        dispatch( {
            type: actions.GET_PICTURE,
            pictureIsFetching: true,
            pictureIsError: false,
            }
         )

        // fetch( url )
        //     .then( ( response ) => response.text() )
        //     .then( ( url ) => dispatch( setPicture( personId, url) ) )
        //     .catch( ( error ) => {
        //         console.log('ERROR:', error )
        //     });
    }
}

    export const postPicture = ( personId, form ) => {
    const  url = new Request (`https://s3.intouchnetworks.com/uploadImage.php`);
    const  url2 = new Request (`https://s3.intouchnetworks.com/getImage.php?id=${ personId }`);

    const headers =  {
        method: "post",
        mode: 'cors',
        headers: {
            'Accept': 'application/json, application/xml, text/plain, text/html, *.*',
        },
        body: form,
    };

    return dispatch => {
        dispatch( {
                type: actions.POST_PICTURE_REQUEST,
                pictureIsPosting: true,
                pictureIsError: false,
            }
        )
        fetch( url, headers )
            .then( ( response ) => {
                return fetch (url2)
            })
            .then( ( response ) => response.text() )
            .then( ( url) => {
                const isDefault = url.indexOf("default.png") > -1 ? true : false;
                return dispatch ({
                    type: actions.SET_PICTURE,
                    personId,
                    url,
                    isDefault,
                } )
            } )
            .catch( ( error ) => {
                console.log('ERROR:', error )
            });

      dispatch(updateTodoList(personId, 8));
    }
}



// WEBPACK FOOTER //
// src/client/components/site/features/profile/actions/picture.js